export class NormalizedHttpErrorValueObject {
  constructor(
    public readonly status: number | undefined,
    public readonly message: string,
    public readonly url?: string,
    public readonly method?: string,
    public readonly code?: string,
  ) {}
}
